import React from 'react'
import IconFont, {
  SimpleLineIconsTypes
} from '../../components/common/IconFont'
import './AnalyticsHighlight.less'

interface IPercentageInput {
  part: number | null
  total: number | null
}

export enum AnalyticsHighlightTextColorEnum {
  black = 'black',
  grey = 'grey'
}

export const percentageOfTotalFormatter = (input: IPercentageInput) => {
  const { part, total } = input
  if (!total || typeof part !== 'number') {
    return '-'
  }
  const onePercent = total / 100

  return `${Math.round(part / onePercent)}%`
}

export function AnalyticsHighlight({
  value,
  icon,
  description,
  percentage,
  iconColor,
  textColor = AnalyticsHighlightTextColorEnum.black,
  dataTest = 'AnalyticsHighlight'
}: {
  value?: number | string
  icon?: SimpleLineIconsTypes | JSX.Element
  description: string | JSX.Element
  percentage?: IPercentageInput
  iconColor?: 'green' | 'blue' | 'grey' | 'purple' | 'red'
  textColor?: AnalyticsHighlightTextColorEnum
  dataTest?: string
}) {
  let renderVal
  if (percentage) {
    renderVal = percentageOfTotalFormatter(percentage)
  } else {
    if (String(value).match(/NaN|Infinity/)) {
      renderVal = 0
    } else {
      renderVal = value
    }
  }

  const textClassName =
    textColor !== AnalyticsHighlightTextColorEnum.black
      ? `AnalyticsHighlight--text-${textColor}`
      : ''

  return (
    <div className={`AnalyticsHighlight AnalyticsHighlight--${iconColor}`}>
      {icon &&
        (typeof icon === 'string' ? (
          <IconFont type={icon} className="AnalyticsHighlight__icon" />
        ) : (
          <div className="AnalyticsHighlight__icon">{icon}</div>
        ))}
      <span className="AnalyticsHighlight__value">
        <h2 className={textClassName} data-test={dataTest}>
          {renderVal}
        </h2>
        <p className="AnalyticsHighlight__desc">{description}</p>
      </span>
    </div>
  )
}
